export default __webpack_public_path__ + "static/media/oola_white_logo.b8a40068.svg";